module.exports = __webpack_public_path__ + "static/media/purificadorF.1e2f18fa.pdf";